import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import {
  useTheme,
  Grid,
  Stack,
  Dialog,
  DialogContent,
  Typography,
  TextField,
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { tokens } from "../theme";
import CustomButton from "./CustomButton";

import dayjs, {  } from "dayjs";
import DebugLog from "../utils/DebugLog";
import FancyRadioButtonGroup from "./FancyRadioButtonGroup";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { initializeEncryption } from "../services/AesGcmEncryption";
import { getFromLocalStorage, getFromLocalStorageJsonObject, saveToLocalStorageJsonObject } from "../utils/localStorageUtils";
import { AWAITING_FILE_DOWNLOAD, MESSAGE_KEY } from "../constants/LocalStorageKeyValuePairString";
import { ApiErrorCode, ApiType } from "../services/ApiTags";
import { ALERT, ERROR, ERROR_WHILE_FETCHING_DATA, PROCESSING_PLEASE_WAIT } from "../constants/Strings";
import { showErrorAlertDialog, triggerFileDownload } from "../config/AppConfig";
import { useAtom } from "jotai";
import useAxiosHook from "../hooks/UseAxios";
import styled from "styled-components";
import ShowErrorAlertDialog from "./ErrorAlertDialog";
import CustomProgressDialog from "./CustomProgressDialog";
import useAxiosHookForDownloadReportInitiate from "../hooks/UseAxiosForReportDownloadInititate";
import { LOGIN } from "../constants/Constant";
import { useNavigate } from "react-router-dom";
export const DownloadPayoutOnHoldReportNameSelectionDialog = ({
  open,
  handleClose,
  handleSubmit,
  batchNo,
  type,
  titleText,
  reportNameOption,
  reportNamesList
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedFile, setSelectedFile] = useState(null);
  const [comment, setComment] = useState("");

  const [reportNameVisibility, setReportNameSelectionVisibility] = useState(false);
  const [datePickerVisibility, setDatePickerVisibility] = useState(false);
  const [fileChooseVisibility, setFileChooseOptionVisibility] = useState(false);

  const [selectedFileTypeValue, setSelectedFileTypeValue] = useState("XLS");

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const { data, error, showProgressBar, fetchData } = useAxiosHook();
  const {
    downloadedDataFromInitiateApi, downloadInitiateApiError, showProgressBarForDownloadInitiate, fetchDataFromDownloadInitiate
  } = useAxiosHookForDownloadReportInitiate();

  const [errors, setErrors] = useState({});
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const dropdownHeight = "400px"; // Set the desired height
  const [reportTemplate, setReportTemplate] = useState("");
  const [reportFormat, setReportFormat] = useState("");
  const [triggerDownload, setInititateFileDownloadTrigger] = useAtom(triggerFileDownload);

  const [reportNameOptions, setReportNameOptions] = useState([]);
  const [reportNamesValue, setReportNamesValue] = useState([]);


  const StyledInputLabel = styled(InputLabel)({
    height: "40px", // Set the desired height for the InputLabel
  });

  const handleFileTypeSelectionChange = (event) => {
    setSelectedFileTypeValue(event.target.value);
  };

  const availableFileTypeOptions = [
    { value: "XLS", label: "XLSX" },
    { value: "PDF", label: "PDF" },
    { value: "CSV", label: "CSV" },
  ];
  const dropdownStyle = {
    maxHeight: dropdownHeight,
    overflowY: "auto", // Add a scrollbar if needed
  };

  // const classes = useStyles();
  const [formData, setFormData] = useState({
    name: "",
  });
 

  useEffect(() => {
    setStartDate(null)
    setEndDate(null)
   
  }, []);

  useEffect(() => {
    if(reportNameOption!==null && reportNameOption!==undefined && reportNameOption.length>0){
      setReportNameOptions(reportNameOption)
    }
   
  }, [reportNameOption]);

  useEffect(() => {
    if(reportNamesList!==null && reportNamesList!==undefined && reportNamesList.length>0){
    setReportNamesValue(reportNamesList)
    }
  }, [reportNamesList]);

  useEffect(() => {
    if(batchNo!==null){
     // getReportNamesFromApi(batchNo)
    }
}, [open]);

useEffect(() => {
  if (showProgressBarForDownloadInitiate) {
    setProgressbarText(PROCESSING_PLEASE_WAIT);
    setLoading(true);
  } else {
    setLoading(false);
  }
}, [showProgressBarForDownloadInitiate]);
useEffect(() => {
  if (downloadInitiateApiError) {
    if(downloadInitiateApiError.message!==null && downloadInitiateApiError.message==="Network Error"){
      showErrorAlert(
        ERROR,
        downloadInitiateApiError.message
      );
    }
  //  else if (
  //     downloadInitiateApiError.data !== null &&
  //     downloadInitiateApiError.data.responseCode !== null &&
  //     downloadInitiateApiError.data.responseCode !== "-1"
  //   ) {
  //     const message =
  //       downloadInitiateApiError.response !== null
  //         ? downloadInitiateApiError.response
  //         : downloadInitiateApiError.message;
  //     showErrorAlert(
  //       downloadInitiateApiError.message,
  //       ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
  //     );
  //   }
     else   if (downloadInitiateApiError.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
        alert(downloadInitiateApiError.data.displayErrorMessage)
        navigate(LOGIN)
      }else{
      const message =
        downloadInitiateApiError.data !== null
          ? downloadInitiateApiError.data.displayErrorMessage
          : downloadInitiateApiError.message;
      showErrorAlert(
        ERROR,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  
  }
}, [downloadInitiateApiError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  

 
  // useEffect(() => {
  //   if (showProgressBar) {
  //       setProgressbarText(LOADING_REPORT_NAMES_PLEASE_WAIT);
  //       setLoading(true);
  //   } else {
  //      setLoading(false);
  //   }
  // }, [showProgressBar]);



  useEffect(() => {
    if (error) {

      if(error.message!==null && error.message==="Network Error"){
        showErrorAlert(
          ERROR,
          error.message
        );
      }
      else  if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
          alert(error.data.displayErrorMessage)
          navigate(LOGIN)
        }else{
        const message =
          error.data !== null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA+ JSON.stringify(message)
        );
        }
      }
      handleClose();
    
  }, [error]);


  const onSubmit = () => {
    // if( selectedFileTypeValue===""){
    //     alert("Please choose a download file format!")
    // } else {
   // const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
   const newErrors = {};
   if (!formData.name) {
    newErrors.name = "name is required";
  }

  if (Object.keys(newErrors).length === 0) {
    // Form is valid, submit the data

    const selectedReportName = formData.name.toUpperCase
    setInititateFileDownloadTrigger(false)

   // const selectedFileType = fileType === "xlsx"? "XLS" :"PDF"
    initiateRequestForReportDownload(batchNo,reportTemplate,reportFormat);
    //handleClose();
    
  } else {
    // Form is not valid, update the errors state
    setErrors(newErrors);
  }

//     const startDateValue = dayjs(startDate);
//     const endDateValue = dayjs(endDate);
    
//     if(!startDateValue.isValid()){
//       alert("Please choose start date")
//     }else if(!endDateValue.isValid()){
//       alert("Please choose End date")
//     }
//    else if(startDateValue.isAfter(endDateValue)){
//        alert("Start date should be less than End date")
//     }else if(startDateValue.isSame(endDateValue)){
//       alert("Start date  & End date should not be same")

//     }else if(selectedFileTypeValue===null || selectedFileTypeValue===""){
//       alert("Please choose download File Format!")
    
//     }else{

//       const formatStartDate = startDateValue.format('DD/MM/YYYY')
//       const formatEndDate = endDateValue.format('DD/MM/YYYY')

//       handleSubmit(selectedFileTypeValue,  type, formatStartDate,formatEndDate);
//       setSelectedFileTypeValue("");
//       setSelectedDate(today);
//       handleClose();
//     }

  };

  useEffect(() => {
    switch (type) {
      case "Download":
        setReportNameSelectionVisibility(true)
        setDatePickerVisibility(false);
        setFileChooseOptionVisibility(false);
        break;

      default:
        setReportNameSelectionVisibility(true)
        setDatePickerVisibility(false);
        setFileChooseOptionVisibility(false);
        break;
    }
  }, [type]);

  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
    if (newValue > endDate) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (newValue) => {
    if (!startDate || newValue >= startDate) {
      setEndDate(newValue);
    }
  };
 
  const handleReportNamesSelection = (option) => {
    for (let i = 0; i < reportNamesValue.length; i++) {
      const model = reportNamesValue[i];
      if (model.reportName === option) {
        setReportTemplate(model.reportTemplate);
        setReportFormat(model.reportFormat)
      }
    }
  };

 


  function initiateRequestForReportDownload(batchNo,reportName,fileType) {
    try {
      
        const requestObject = {
            batchNo: batchNo,
            reportTemplate:reportName,
            reportFormat:fileType
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.INITIATE_REPORT_PREPRATION
        ).then((encryptedContentData) => {
         
          fetchDataFromDownloadInitiate(process.env.REACT_APP_REPORT_DOWNLOAD_INITIATE_API_URL,ApiType.INITIATE_REPORT_PREPRATION,ApiType.POST_METHOD, encryptedContentData, {}, (data) => {
            if (data !== null) {
            
               
                const alreadyAwaitingDownloadFiles = getFromLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD)
                if(alreadyAwaitingDownloadFiles===undefined || alreadyAwaitingDownloadFiles===null){
                  const newFileDownloadList = []
                  const newFileForDownload = {
                    reportName:reportName,
                    fileReferenceToken : data.result.fileReferenceToken,
                    fileGenerationStatus:data.result.fileGenerationStatus,
                    fileDownloadPath:data.result.fileDownloadPath,
                   }
                   newFileDownloadList.push(newFileForDownload);

                   saveToLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD,newFileDownloadList)
                   
                }else{
                  const newFileDownloadList = []
                  for(let i=0;i<alreadyAwaitingDownloadFiles.length;i++){
                    const model = alreadyAwaitingDownloadFiles[i]
                    newFileDownloadList.push(model)
                  }
                  
                   const newFileForDownload = {
                    reportName:reportName,
                    fileReferenceToken : data.result.fileReferenceToken,
                    fileGenerationStatus:data.result.fileGenerationStatus,
                    fileDownloadPath:data.result.fileDownloadPath,
                   }

                   newFileDownloadList.push(newFileForDownload)
                 
                  saveToLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD,newFileDownloadList)
                }

               showErrorAlert(ALERT,"Your file will be downloaded soon , please check progress in the notification bar.")

                setInititateFileDownloadTrigger(true)
                handleClose();
            }
          });

        
        });
      
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }


  function getReportNamesFromApi(batchNo) {
    try {
      
        const requestObject = {
            batchNo: batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_REPORT_NAMES_LIST
        ).then((encryptedContentData) => {
         
          fetchData(process.env.REACT_APP_REPORT_NAMES_API_URL,ApiType.GET_REPORT_NAMES_LIST,ApiType.POST_METHOD, encryptedContentData, {}, (data) => {
            if (data !== null) {
              if (
                data.result.reportNames.length > 0
              ) {
                setReportNameOptions(
                  data.result.reportNames.map(
                    (item) => item.reportTemplate
                  )
                );
                setReportNamesValue(
                  data.result.reportNames
                );
              } else {
                showErrorAlert(
                  "Alert",
                  "Error in loading Report Names, Please try again!!"
                );
              }

            }
          });

        
        });
      
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);

      
    } catch (error) {
      DebugLog(error);
    }
  }
  return (
    <Box>
    <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
          <CustomProgressDialog open={loading} text={getProgressbarText} />
       
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          background: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent
        sx={{
          background: "white",
          borderRadius: "12px",
          overflow: "initial",
          marginBottom: "15px",
        }}
      >
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          alignContent={"center"}
          justifyItems={"center"}
          justifyContent={"center"}
        >
          <Grid container xs={10}>
            <Grid container justifyContent={"center"}>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                {titleText}
              </Typography>
            </Grid>

            <Grid container>
            {reportNameVisibility  && reportNameOptions.length > 0 && (
            <Grid item xs={12}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          error={!!errors.description}
                        >
                          <StyledInputLabel id="demo-simple-select-outlined-label">
                            Select Report Name
                          </StyledInputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="name"
                            //value={selectedValue}
                            // onChange={handleTypeDropdownChange}
                            label="name"
                            inputProps={{ style: { height: "20px" } }}
                            fullWidth
                            value={formData.name}
                            onChange={handleInputChange}
                            error={Boolean(errors.name)}
                            helperText={errors.name}
                            MenuProps={{ PaperProps: { style: dropdownStyle } }} // Apply styles to the dropdown menu
                          >
                            {reportNameOptions.map((option, index) => (
                              <MenuItem
                                key={index}
                                value={option}
                                onClick={() => handleReportNamesSelection(option)}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{errors.name}</FormHelperText>
                        </FormControl>
                      </Grid>
                       )}
                    
              {datePickerVisibility && (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Box
                  mt={5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                </LocalizationProvider>
              )}

              
              <Grid container justifyContent={"flex-start"} mt={3} pb={2}>
                {/**** Attach File ***/}
                {fileChooseVisibility && (
                  <>
                    <label>File Format</label>

                    <label
                      htmlFor="file-upload"
                      style={{
                        border: "1px solid #94B0E0",
                        borderRadius: "64px",
                        width: "100%",
                        textAlign: "center",
                        margin: "15px auto",
                        fontSize: "12px",
                        fontWeight: "700",
                        letterSpacing: "1.25px",
                        padding: "6px 24px",
                        textTransform: "uppercase",
                        cursor: "pointer",
                      }}
                    >
                      <FancyRadioButtonGroup
                        label=""
                        value={selectedFileTypeValue}
                        onChange={handleFileTypeSelectionChange}
                        options={availableFileTypeOptions}
                      />
                    </label>
                  </>
                )}

                <Grid container justifyContent={"flex-end"}>
                  <Stack
                    direction="row"
                    pt={2}
                    spacing={2}
                    justifyContent={"center"}
                  >
                    <CustomButton
                      btnBG={colors.primary[900]}
                      btnColor={colors.grey[100]}
                      btnTxt={"Cancel"}
                      btnBorder={"1px solid" + colors.primary[800]}
                      onClick={handleClose}
                    ></CustomButton>

                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={"Download"}
                      btnBorder={"1px solid" + colors.primary[100]}
                      onClick={onSubmit}
                    ></CustomButton>

                    {/* 
                    <Button onClick={} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onSubmit} color="primary">
                    Submit
                  </Button> */}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      {/* <DialogActions> */}

      {/* </DialogActions> */}
    </Dialog>

    </Box>
  );
};
